import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-2xl font-bold tracking-tight text-gray-900" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "fa fa-folder" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "leading-8 text-gray-800" }, "Title", -1)
const _hoisted_4 = { class: "mt-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "leading-8 text-gray-800" }, "Description", -1)
const _hoisted_6 = { class: "mt-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "leading-8 text-gray-800" }, "Image url", -1)
const _hoisted_8 = { class: "mt-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "leading-8 text-gray-800" }, "Parent folder", -1)
const _hoisted_10 = { class: "relative" }
const _hoisted_11 = { class: "mt-4 flex justify-end gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_TreeSelect = _resolveComponent("TreeSelect")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Sidebar = _resolveComponent("Sidebar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmDialog),
    _createVNode(_component_Sidebar, {
      visible: $data.visible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (($data.visible) = $event)),
      position: "right",
      dismissable: false
    }, {
      header: _withCtx(() => [
        _createElementVNode("h2", _hoisted_1, [
          _hoisted_2,
          _createTextVNode(" " + _toDisplayString($options.isNewFolder ? "New folder" : "Edit folder"), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_3,
          _createVNode(_component_InputText, {
            modelValue: $data.folder.title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.folder.title) = $event)),
            class: "w-full"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_Textarea, {
            modelValue: $data.folder.description,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.folder.description) = $event)),
            class: "w-full",
            autoResize: ""
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_InputText, {
            modelValue: $data.folder.imageUrl,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.folder.imageUrl) = $event)),
            class: "w-full"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_TreeSelect, {
              modelValue: $options.parentFolderNode,
              "onUpdate:modelValue": $options.onNodeSelect,
              selectionMode: "single",
              options: $options.buildFolderNodeTree(),
              placeholder: "Select the parent folder",
              class: "w-full"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]),
            _createElementVNode("span", {
              class: "pi pi-times text-gray-500 cursor-pointer absolute right-12 top-1/2 -mt-2",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (this.folder.parentFolderId = null), ["stop"]))
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          ($options.isNewFolder)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                onClick: $options.create,
                icon: "fa-solid fa-floppy-disk",
                label: "Create",
                loading: $data.saveLoading
              }, null, 8, ["onClick", "loading"]))
            : (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                onClick: $options.save,
                icon: "fa-solid fa-floppy-disk",
                label: "Save",
                loading: $data.saveLoading
              }, null, 8, ["onClick", "loading"])),
          (!$options.isNewFolder && _ctx.canDelete)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 2,
                onClick: _cache[4] || (_cache[4] = ($event: any) => ($options.confirmDelete($data.folder))),
                severity: "danger",
                outlined: "",
                icon: "fa fa-trash",
                label: "Delete",
                loading: $data.deleteLoading
              }, null, 8, ["loading"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}